import React from "react";

export const SingleProductDescriptionFocusedPrice = ({
  product,
  isRetailMerchant,
}: any) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    }).format(price / 100);
  };

  if (!product.available) {
    return <span className="self-start pt-[2px] font-medium">Unavailable</span>;
  }

  return (
    <p
      className={[
        "self-start pt-[2px] text-base leading-6 !font-medium !text-[14px]",
      ].join(" ")}
    >
      {formatPrice(product.price)}
    </p>
  );
};
